module.exports = __webpack_public_path__ + "img/Group 5147.09da5aba.png";